module.exports = __webpack_public_path__ + "static/media/baileyLindley05.1cd683a1.jpg";